// export this package's api
import Drawer from './DrawerWrapper';
export default Drawer;


//////////////////
// WEBPACK FOOTER
// ../~/rc-drawer/es/index.js
// module id = 1233
// module chunks = 0